import { render, staticRenderFns } from "./TypographyDefault.vue?vue&type=template&id=a88ea18a&"
import script from "./TypographyDefault.vue?vue&type=script&lang=js&"
export * from "./TypographyDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports